export function scrollPosition(headerHeight: number, value: number) {
  return headerHeight * 0.01 * value;
}
